import smartSolveApi from './instances/smartsolve';
import { getEnvVar } from '../utils/env';

export const getOnlineCollaboration = async ({
  itmId: id,
  clientPath,
  stepId,
  workflowId,
  entityType,
  formKey,
  documentUser = 'Collaborator',
  action = 'edit',
  documentType = 'DOCUMENT',
  navigationAction = 'Edit',
  closeAction = 'edit',
  ...params
}) => {
  try {
    const response = await smartSolveApi.post('/officeonlineurl', {
      id,
      stepId,
      clientPath,
      absolutePath: `${getEnvVar('REACT_APP_ADMIN_APP_URL').replace(/https?:\/\/|\/apis\//g, '')}`,
      entityType,
      formKey,
      workflowId,
      documentUser,
      action,
      documentType,
      navigationAction,
      closeAction,
      ...params,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getOnlineCollaboration() failed: ${e}`);
  }
};

export const getDocumentHeaderParams = async ({
  docId,
  documentNumber,
  documentRevision,
  getLatestRevision,
  contentType,
  entityName,
}) => {
  try {
    const response = await smartSolveApi.post('/getdocumentheaderparams', {
      docId,
      documentNumber,
      documentRevision,
      getLatestRevision,
      contentType,
      entityName,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getDocumentHeaderParams() failed: ${e}`);
  }
};

export const getActiveDeviationForDocument = async ({ docId }) => {
  try {
    const response = await smartSolveApi.post('/activedeviationfordocument', {
      docId,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getActiveDeviationForDocument() failed: ${e}`);
  }
};

export function compareDocument(params) {
  return smartSolveApi.post('/documentcompare', params, {
    responseType: 'blob',
  });
}

export function compareDocumentContentHistory(params) {
  return smartSolveApi.post('/DocumentContentHistoryCompare', params, {
    responseType: 'blob',
  });
}

export const getSharePointUrl = async (documentData) => {
  try {
    const response = await smartSolveApi.post('/sharepointurl', documentData);

    return response.data;
  } catch (e) {
    throw new Error(`getSharePointUrl() failed: ${e}`);
  }
};

export const getRequestControlPrint = async (params) => {
  try {
    const response = await smartSolveApi.post('/RequestControlPrint', params, {
      responseType: 'blob',
    });
    return response;
  } catch (e) {
    throw new Error(`getRequestControlPrint() failed: ${e}`);
  }
};

export const getRequestControlPrintBatch = async (params) => {
  try {
    const response = await smartSolveApi.post('/RequestCtrlPrintBatch', params, {
      responseType: 'blob',
    });
    return response;
  } catch (e) {
    throw new Error(`getRequestControlPrintBatch() failed: ${e}`);
  }
};
